<script lang="ts">
	import IconButton, { Icon } from '@smui/icon-button/styled';

	export let imageSrc = '';
</script>

<IconButton style={`${imageSrc && 'padding: 8px 8px 8px 9px;'}`} on:click aria-label="User account">
	{#if imageSrc}
		<img alt="User profile" src={imageSrc} />
	{:else}
		<Icon class="material-icons">account_circle</Icon>
	{/if}
</IconButton>

<style>
	img {
		height: 32px;
		width: 32px;
		border-radius: 50%;
	}
</style>
